import React from "react";
import PropTypes from "prop-types";
import { withStyles } from '@mui/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';
import Paper from '@mui/material/Paper';
import NotFoundTableRow from "../NotFoundTableRow";
import DutyStatus from "../../components/DutyStatus";
import {LABELS as _LABELS} from "../../language";



const LABELS=_LABELS.dutyPage;
const LABEL=_LABELS.adminPage;

const styles = theme => ({
    root: {
        width: "98%",
        marginRight: "auto",
        marginLeft: "auto",
        marginTop: theme.spacing(1),
        overflowX: "auto"
    },
    table: {
        minWidth: 700
    },
    tableHead: {
        // padding: 5,
        // minWidth: 130
    },
    tableRowTitle: {
        display: "inline-block"
        // width: 95
    },
    capitalize: {
        textTransform: "capitalize"
    },
    saveIcon: {
        color: "#009be5",
        cursor: "pointer"
    }
});

class ReduxTableRow extends React.Component {
    render() {
        const { classes, item = {} } = this.props;
        const driver = item.driver;
        const vehicle = item.vehicle;

        return (
            <TableRow hover>
                <TableCell>
                    <div>{this.props.formatTime(item.eventTime)}</div>
                    {this.props.formatDate(item.eventTime)}
                </TableCell>
                <TableCell>
                    <div className={classes.capitalize}>
                        {driver && (
                            <div>
                                {driver.firstName} {driver.lastName}
                            </div>
                        )}
                    </div>
                </TableCell>
                <TableCell>
                    <DutyStatus
                        status={item}
                        eventType={item.eventType}
                        eventCode={item.eventCode}
                        annotation={item.annotation}
                        eventSubType={item.eventSubType}
                    />
                </TableCell>
                <TableCell>{vehicle ? vehicle.name : ""}</TableCell>
                <TableCell>
                    {item.annotation ? <div>{item.annotation}</div> : ""}
                    {item.reason ? <div>{item.reason}</div> : ""}
                </TableCell>
            </TableRow>
        );
    }
}

export class ReduxTable extends React.Component {
    state = {
        order: "asc"
    };

    handleChangePage = (event, page) => {
        const { limit } = this.props;
        this.props.handleChange({ page, limit });
    };

    handleChangeRowsPerPage = event => {
        const limit = event.target.value;
        const { page } = this.props;
        this.props.handleChange({ page, limit });
    };

    render() {
        const { classes, items = [], count} = this.props;
        const { page, limit } = this.props;

        return (
            <Paper className={classes.root}>
                <Table className={classes.table}>
                    <TableHead>
                        <TableRow>
                            <TableCell>{LABELS.date}</TableCell>
                            <TableCell>{LABELS.driver}</TableCell>
                            <TableCell>{LABELS.status}</TableCell>
                            <TableCell>{LABELS.vehicle}</TableCell>
                            <TableCell>{LABELS.reason}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {Array.isArray(items) &&
                            items.map((item, i) => (
                                <ReduxTableRow
                                    item={item}
                                    key={i}
                                    classes={classes}
                                    formatDate={this.props.formatDate}
                                    formatTime={this.props.formatTime}
                                />
                            ))}
                    </TableBody>
                </Table>
                <NotFoundTableRow items={items} />
                <TablePagination
                    rowsPerPageOptions={[10, 25, 50, 100, 500, 1000]}
                    component="div"
                    count={count}
                    rowsPerPage={limit}
                    page={page}
                    onPageChange={this.handleChangePage}
                    onRowsPerPageChange={this.handleChangeRowsPerPage}
                    labelRowsPerPage={LABEL.rowsperpage}
                />
            </Paper>
        );
    }
}

ReduxTable.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(styles)(ReduxTable);
